export const VIEWPORT_TOP_OFFSET = 100; // this is to accomodate for the fixed subnav
